<template>
  <div>
    <div class="page-content border-bottom">
      <!-- 顶部搜索框 -->
      <div>
        <el-form :inline="true" :model="searchInfo" class="demo-form-inline">
          <el-form-item label="礼品名称">
            <el-input v-model="searchInfo.awardName" placeholder="请输入礼品名称" class="form-item-width" clearable></el-input>
          </el-form-item>
          <el-form-item class="right-btns">
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button @click="onReset">重置</el-button>
            <el-button type="primary" @click="onAddUser">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 表格展示区域 -->
    <div class="page-content margin-top">
      <!-- 表格组件 -->
      <el-table :data="tableData" stripe style="width: 100%"  border
        :header-cell-style="{ background: '#eef1f6', color: '#606266','text-align':'center' }"
        :cell-style="{'text-align':'center'}"  height="66vh" scroll-y
      >
        <!-- 循环展示表格 -->
        <!-- <el-table-column v-for="tab in tableTitle" :key="tab.code" :label="tab.name" show-overflow-tooltip -->
          <!-- :width="tab.width" > -->
          <!-- <template slot-scope="scope"> -->
            <!-- <template v-if="tab.code === 'awardPic'">
              <img :src="scope.row[tab.code]" class="table-image">
            </template> -->
            <!-- <span>{{ scope.row[tab.code] }}</span> -->
            <!-- <span>{{ scope.row[tab.code] }} </span> -->
          <!-- </template> -->
        <!-- </el-table-column> -->
        <el-table-column label="礼品名称" prop='awardName'></el-table-column>
        <el-table-column label="礼品价格" prop='awardCost' width="170px"></el-table-column>
        <el-table-column label="兑换积分" prop='awardPoints' width="170px"></el-table-column>
        <el-table-column label="展示图" prop='awardSourcePic'>
          <template slot-scope="scope">
            <img :src="scope.row.awardSourcePic" style="width: 50px; height: 50px;" />
          </template>
        </el-table-column>
        <el-table-column label="状态" prop='isEffect' width="170px">
          <template slot-scope="scope">
            <span v-if="scope.row.isEffect === 1" style="color: #008000">已上架</span>
            <span v-else-if="scope.row.isEffect === 0" style="color: #f56c6c">未上架</span>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-popconfirm v-if="scope.row.isEffect === 1" :title="`确定下架商品${scope.row.awardName}吗？`" @confirm="updateAwardEffect(scope.row)"
             icon="el-icon-delete" icon-color="skyblue">
              <span  slot="reference" class="top-btn">下架商品</span> 
            </el-popconfirm>
            <el-popconfirm v-else :title="`确定上架商品${scope.row.awardName}吗？`" @confirm="updateAwardEffect(scope.row)"
             icon="el-icon-delete" icon-color="skyblue">
              <span  slot="reference" class="top-btn">上架商品</span> 
            </el-popconfirm>

            <span @click="updateRow(scope.row)" class="update-btn">修改</span>
            <el-popconfirm :title="`确定删除${scope.row.awardName}吗？`" @confirm="deleteRow(scope.row)"
             icon="el-icon-delete" icon-color="skyblue">
              <span slot="reference" class="delete-btn">删除</span> 
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <div>
        <Pagination :total="dataTotal" :page="searchInfo.page" :limit="searchInfo.limit" @pagination="onChangePages" />
      </div>
    </div>

    <!-- 新增弹框 -->
    <el-dialog :title="isUpdate ? '修改' : '新增'" :visible.sync="dialogVisible" top="5vh" width="672px">
      <el-form ref="form" class="dialog-form" :model="accountEdit" :rules="rules" label-width="110px">
        <el-form-item label="礼品名称" prop="awardName">
          <el-input v-model="accountEdit.awardName" placeholder="请输入礼品名称"></el-input>
        </el-form-item>
        <el-form-item label="礼品价格" prop="awardCost">
          <el-input v-model="accountEdit.awardCost" placeholder="请输入礼品价格"></el-input>
        </el-form-item>
        <el-form-item label="兑换积分" prop="awardPoints">
          <el-input v-model="accountEdit.awardPoints" placeholder="请输入兑换积分"></el-input>
        </el-form-item>
        <el-form-item label="图片上传" prop="awardPic">
          <el-upload
            action="#" 
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="fileList"
            :limit="1"
            :http-request="uploadSuccess"
            :multiple="false"
            ref="upload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogUpload">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="onSubmitDialog()">确定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { getGiftLift,getAddGift,getDeleteGift,updateAwardEffect } from '../../api/gift'
import { uploadImage,initOSSClient,deleteImage} from '../../api/uploadFile'

export default {
  components: {
    Pagination
  },
  data() {
    return {
      // 查询数据
      searchInfo: {
        awardName: '',
        page: 1,
        size: 20,
      },
      // 新增弹框表单信息
      accountEdit: {
        awardName: '',
        awardCost:'',
        awardPoints:'',
        awardPic:'',
        awardSourcePic:'',
      },

      fileList: [],
      dialogImageUrl:'',
      dialogUpload:false,

      // 表格数据
      tableData: [],
      // 数据总数
      dataTotal: 0,
      // 标记是否新增
      isUpdate: false,
      // 是否展示弹框
      dialogVisible: false,

      // 表格标题数组
      // tableTitle: [
      //   { name: '礼品名称', code: 'awardName', width: '' },
      //   { name: '礼品价格', code: 'awardCost', width: '' },     
      //   { name: '兑换积分', code: 'awardPoints', width: '' },
      //   { name: '展示图', code: 'awardPic', width: '' } 
    // ],
      //表单校验规则对象
      rules: {
        awardName: [
          { required: true, message: '请输入礼品名称', trigger: 'blur' }
        ],
        awardCost: [
          { required: true, message: '请输入礼品价格', trigger: 'blur' }
        ],
        awardPoints: [
          { required: true, message: '请输入兑换积分', trigger: 'blur' }
        ],
      },
      
    }
  },

  mounted() {
    // 获取列表数据
    this.onSearch()
  },
  methods: {
    // 查询按钮
    onSearch() {
      this.searchInfo.page = 1
      this.onGetDataList()
    },
    // 获取列表
    async onGetDataList() {
      // 分类接口
      const client = await initOSSClient();
      const data = await getGiftLift(this.searchInfo)
      this.tableData = data.data.records
      this.dataTotal = data.data.total
      this.tableData = this.tableData.map(item=>{
        item.awardSourcePic = client.signatureUrl(item.awardPic);
        return item;
      })
    },
    // 重置按钮
    onReset() {
      this.searchInfo.awardName = ''
      this.onSearch()
    },

    // 新增按钮
    onAddUser() {
      this.fileList =[];
      this.accountEdit.awardSourcePic = '';
      this.accountEdit.awardPic = '';
      this.isUpdate = false
      this.dialogVisible = true
      this.accountEdit = {
        id:0,
        awardName: '',
        awardCost:'',
        awardPoints:'',
        awardPic:'',
      } 
      //清空校验规则错误提示信息
      this.$nextTick(()=>{
        this.$refs.form.clearValidate()
      })
    },
    // 修改按钮
    updateRow(row) {
      this.isUpdate = true
      this.dialogVisible = true 
      //清空校验规则错误提示信息
      this.$nextTick(()=>{
        this.$refs.form.clearValidate()
      })
      Object.assign(this.accountEdit, row)
      this.fileList=[{
        name: 'preview-image',
        url: row.awardSourcePic
      }];
    },
    async handleRemove() {
      console.log(this.accountEdit.awardSourcePic)
      //this.consume.imageUrl = '' // 清空图片URL
      const a = await deleteImage(this.accountEdit.awardSourcePic);
      console.log(a)
      this.accountEdit.awardSourcePic = '';
      this.accountEdit.awardPic = '';
      this.fileList =[];
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogUpload = true;
    },
    // async uploadSuccess(file){
    //   let formData = new FormData()
    //   formData.append("memId", this.consume.id)
    //   formData.append("file", file.file)
    //   const data = await getUploadImg(formData)
    //   if (data.code == '200') {
    //     this.consume.voucherPic = data.data
    //     this.msgsuccess('上传成功')
    //   } 
    // },

    handleFileChange(e) {
      this.file = e.target.files[0]
    },
   
    async uploadSuccess(file) {
      try {
        // const result = await this.client.put(fileName, file.file)
        const url =await uploadImage(file.file);
        this.accountEdit.awardPic = url
        this.msgsuccess('上传成功')
      } catch (err) {
        this.msgsuccess('上传失败')
      }
    },
    
    // 删除按钮
    async deleteRow(row) {
      const gift = {id:row.id}
      const data = await getDeleteGift(gift)
      if (data.code == '200') {
        this.msgsuccess('删除成功')
        this.onGetDataList()
      } else {
        this.msgerror('删除失败')
      }

    },
    
    // 删除按钮
    async updateAwardEffect(row) {
      if(row.isEffect == 1){
        const gift = {id:row.id,isEffect:0}
        const data = await updateAwardEffect(gift)
        if (data.code == '200') {
          this.msgsuccess('下架商品成功')
          this.onGetDataList()
        } else {
          this.msgerror('下架商品失败')
        }
      }else{
        const gift = {id:row.id,isEffect:1}
        const data = await updateAwardEffect(gift)
        if (data.code == '200') {
          this.msgsuccess('上架商品成功')
          this.onGetDataList()
        } else {
          this.msgerror('上架商品失败')
        }
      }

    },
    // 分页方法
    onChangePages(pageInfo) {
      const { page, limit } = pageInfo
      this.searchInfo.page = page
      this.searchInfo.size = limit
      this.onGetDataList()
    },

    // 弹框确认按钮
    onSubmitDialog() {
      if(this.accountEdit.awardPic == ''){
         this.msgerror('请上传礼品展示图！')
          return;
      } 
      //先进行表单验证，验证通过后再发请求
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = await getAddGift(this.accountEdit)
          if (data.code == '200') {
            this.dialogVisible = false
            this.msgsuccess('保存成功')
            this.onGetDataList()
            this.accountEdit.awardSourcePic = '';
            this.accountEdit.awardPic = '';
            this.fileList =[];
          } else {
            this.dialogVisible = false
            this.msgerror('保存失败')
          }
        } else {
          return false;
        }
      })
    },
    
  
  },
}
</script>

<style lang="less" scoped>
.form-item-width {
  width: 100%;
}

.right-btns {
  position: absolute;
  right: 20px !important;
}

.el-form-item {
  font-weight: bold;
  margin: 0 20px 4px 10px !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e2e4;
}

.margin-top {
  margin-top: -15px;
}

.examine-btn {
  cursor: pointer;
  color: #409eff;
}

.update-btn {
  cursor: pointer;
  color: #409eff;
  margin: 0px 20px;
}

.top-btn{
  cursor: pointer;
  color: rgb(238, 145, 6);
}

.delete-btn {
  cursor: pointer;
  color: #f56c6c;
}

.dialog-form {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
</style>